import type { SpeciesId } from "../data/species.ts";
import { FRONTIER_PAINT_A, FRONTIER_PAINT_B, type Paint } from "./frontier.ts";

/** Frontier species ids: everything after the original roster. */
export type FrontierId = Extract<SpeciesId,
  | "frostbag" | "glacierbag" | "pengwallet" | "coldvault" | "icepup" | "diamondpaws"
  | "candlecub" | "wickwolf" | "shillpion" | "shillscorp" | "sprikle" | "saguarocket" | "humpfund"
  | "emberbit" | "blazebit" | "infernomint" | "gasbull" | "magmabull" | "moltwisp"
  | "ruglet" | "rugwraith" | "mirebot" | "mireshill" | "botfly" | "swarmlord" | "honeytoad" | "honeybaron"
  | "shardling" | "shardking" | "prismpup" | "prismhound" | "nodelet" | "validrake" | "cachemole" | "vaultmole"
  | "genesiwyrm" | "ursarug">;

export const FRONTIER_PAINT: Partial<Record<FrontierId, Paint>> = {
  ...FRONTIER_PAINT_A,
  ...FRONTIER_PAINT_B,
};
